import { Resource } from '@modules/centers/interfaces/resource';
import TableHeader from '@shared/components/tables/table-header/table-header.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FullCalendar, { CalendarOptions, EventApi, DateSelectArg } from '@fullcalendar/vue';
// import { Calendar } from '@fullcalendar/core';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';
import adaptivePlugin from '@fullcalendar/adaptive';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import scrollGrid from '@fullcalendar/scrollgrid';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { BookingEvent } from '@bookings/interfaces/booking-event';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import TableFooter from '@shared/components/tables/table-footer/table-footer.vue';
import { Discipline } from '@centers/interfaces/discipline';
import moment from 'moment';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { set } from 'lodash';
import { Booking } from '@bookings/interfaces/booking';
import StdxForm from '@shared/components/forms/auto-form/stdx-form/stdx-form.vue';
import VuexFormProvider from '@shared/components/forms/auto-form/vuex-form-provider/vuex-form-provider';
import { Calendar } from '@fullcalendar/core';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import tippy from 'tippy.js';

import resourceTimelinePlugin from '@fullcalendar/resource-timeline';

@Component({
  name: 'bpc-booking-event-calendar-public',
  components: {
    'full-calendar': FullCalendar,
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-table-header': TableHeader,
    'bpc-table-footer': TableFooter,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-entity-select': EntitySelect,
    'bpc-select': Select,
    'bpc-stdx-form': StdxForm,
    'bpc-std-filter': StdFilter,
  },
})
export default class BookingEventCalendarPublic extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    eventForm: InstanceType<typeof StdxForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: VuexFormProvider;
    };
    fcalendar: InstanceType<typeof FullCalendar> & {
      $emit(event): void;
      getApi(): Calendar;
    };
  };

  @Prop({ type: [Number, String], default: null }) readonly tenant_id: number | string;
  @Prop({ type: Number, default: null }) readonly calendarResourceId: number;
  @Prop({ type: Number, default: null }) readonly exclusionsResourceId: number;
  @Prop({ type: String, default: null }) readonly calendarFilterConfigName: number;

  public entity: Booking = null;
  public isLogged: boolean = false;

  public resourcesLoaded: boolean = false;
  public resources: Resource[] = [];
  public selectedResourcesId: number[] = null;

  public disciplinesLoaded: boolean = false;
  public disciplines: Discipline[] = [];
  public selectedDisciplineId: number = null;

  public items: BookingEvent[] = [];
  public allEvents: any[] = [];

  public entityName = 'booking-event';
  public pluralEntityName = 'booking-events';
  public permissionEntityNameToUse = 'bookings';

  public customPageActions = {};
  public customRowActions = {};

  public stdFilterModel = {
    date: null,
    resource__sectors__id: null,
    resource_discipline_id: null,
    exclusions_resource_id: null,
    resources_id: null,
  };

  public resourcesSelectInfo = [];

  public showEventDrawerSection = false;
  public showEventForm = false;
  public bookingEvent: BookingEvent = null;

  public isSimpleBooking = true;
  public headingDate: string = '';
  public filterSectorsLoaded: boolean = false;
  public showPageTitle: boolean = true;
  public showSectors: boolean = false;
  public hideHeading: boolean = false;
  public hideFilters: boolean = false;
  public showResourceNameAsTitle: boolean = false;

  constructor() {
    super();
  }

  get myCustomPageActions() {
    return {
      printCalendar: {
        activated: true,
        type: 'action',
        icon: 'print', //'times',
        variant: 'primary',
        text: 'print',
        show: true,
        event: 'print-calendar',
        selectElements: false,
        buttonClass: !this.resourcesLoaded ? 'disabled' : '',
        disabled: !this.resourcesLoaded,
        tag: 'left',
        permissions: ['read'],
      },
    };
  }

  get pageActions() {
    return {
      ...this.myCustomPageActions,
      ...this.defaultPageActions,
    };
  }

  public get selectedDiscipline(): Discipline {
    return this.disciplines.find(discipline => discipline.id === this.selectedDisciplineId);
  }

  get startLoadingEntities(): boolean {
    return this.$store.getters[`${this.storeName}/loadingEntities`](this.entityName);
  }
  customOnPageAction($event: string) {
    if ($event === 'print-calendar') {
      this.$refs.fcalendar.getApi().changeView('resourceTimeline');
      this.$refs.fcalendar.getApi().setOption('resourceAreaWidth', '10%');
      this.$refs.fcalendar.getApi().setOption('nowIndicator', false);
      window.print();
    }
  }

  onEventFormSave() {
    this.isSavingForm = true;
    console.log('Saving');
    this.allEvents = [];
    this.nextAction = '';
    this.$refs.eventForm.saveEntity();
  }

  onEventFormClose() {
    this.showEventForm = false;
    this.showEventDrawerSection = false;
  }

  public get filterDate(): string {
    return this.stdFilterModel.date || moment().format('YYYY-MM-DD');
  }

  public get selectedSectorId(): number {
    return this.stdFilterModel.resource__sectors__id || null;
  }

  public get slotMinTime() {
    return this.$store.getters['centerSettings/centerSettings'].default_start_hour;
  }

  public get slotMaxTime() {
    return this.$store.getters['centerSettings/centerSettings'].default_end_hour;
  }

  public get defaultSlotDuration() {
    const slotDuration = this.$store.getters['centerSettings/centerSettings'].default_slot_duration;
    const hours = Math.floor(slotDuration / 60);
    const minutes = slotDuration % 60 < 10 ? `0${slotDuration % 60}` : slotDuration % 60;

    return `${hours}:${minutes}:00`;
  }

  public get slotDuration() {
    return this.$store.getters['centerSettings/centerSettings'].default_slot_duration;
  }

  private calendarOptions: CalendarOptions = {
    plugins: [
      resourceTimeGridPlugin,
      interactionPlugin,
      scrollGrid,
      adaptivePlugin,
      resourceTimelinePlugin,
    ],
    schedulerLicenseKey: process.env.VUE_APP_FULLCALENDAR_LICENCE_KEY,
    headerToolbar: {
      left: '',
      center: '',
      right: '',
    },
    resources: [],
    resourceOrder: 'ordering',
    resourceLabelDidMount: function(info) {
      tippy(info.el, {
        content: info.resource.extendedProps.name,
      });
    },
    initialView: 'resourceTimeGrid',
    views: {
      resourceTimeGrid: {
        type: 'resourceTimeGrid',
        duration: { days: 1 },
      },
    },
    initialEvents: 'events', // alternatively, use the `events` setting to fetch from a feed
    // initialDate: this.filterDate,
    viewDidMount: this.gotoCurrentDate,
    editable: false,
    selectable: false,
    selectMirror: true,
    dayMaxEvents: true,
    weekends: true,
    unselectAuto: false,
    select: this.handleDateSelect,
    selectOverlap: this.handleConflictEvents,
    // eventClick: this.handleEventChange,
    eventsSet: this.handleEvents,
    eventDrop: this.dragAndDropEventChange,
    eventOverlap: false,
    datesAboveResources: true,
    dayMinWidth: 100,
    allDaySlot: false,
    slotMinTime: this.slotMinTime,
    slotMaxTime: this.slotMaxTime,
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
      omitZeroMinute: false,
      hour12: false,
      meridiem: false,
    },
    slotLabelFormat: {
      hour: '2-digit',
      minute: '2-digit',
      omitZeroMinute: false,
      hour12: false,
      meridiem: false,
    },
    slotDuration: this.defaultSlotDuration,
    height: 'auto',
    stickyHeaderDates: 'auto',
    //nowIndicator: true,
    nowIndicator: true,
    // eventChange: this.handleEventChange,
    /* you can update a remote database when these fire:
    eventAdd:
    eventChange:
    eventRemove:
    */
  };
  public currentEvents: EventApi[] = [];

  private dragAndDropEvent: any = null;

  getUpdateEventConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'update-event-confirmation-modal',
      title: this.$t('global.modals.update-booking-event.title') as string,
      body: this.$t('global.modals.update-booking-event.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  dragAndDropEventChange(e) {
    this.dragAndDropEvent = e;
    this.bookingEvent = this.items.find(event => event.id === Number(e.event.id));

    const start = moment(e.event.start);
    const end = moment(e.event.end);
    const resourceId = e.event.getResources()[0] ? e.event.getResources()[0].id : null;

    this.bookingEvent.start_time = start.format('HH:mm');
    this.bookingEvent.end_time = end.format('HH:mm');
    this.bookingEvent.date = start.format('YYYY-MM-DD');
    this.bookingEvent.resource_id = resourceId;

    this.$bvModal.show('update-event-confirmation-modal');
  }

  onCancelUpdateEventModal() {
    this.dragAndDropEvent.revert();
    this.dragAndDropEvent = null;
  }

  onConfirmUpdateEventModal(e) {
    const updateEventObservable: Observable<BPCGenericApiResponse> = this.$bpcApi.put(
      `${this.$bpcApiRouteHelper.getEntityPath('booking-event')}/${this.bookingEvent.id}`,
      this.bookingEvent,
      null,
      'public',
    );

    updateEventObservable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
        this.$refs.provider.getEntities();
      },
      error => {
        this.$bvModal.hide('update-event-confirmation-modal');
        this.bookingEvent = null;
        this.$bpcMessage.showErrorMessage({ text: 'global.generic.error_update_action' });
      },
      () => {
        this.bookingEvent = null;
        this.$bvModal.hide('update-event-confirmation-modal');
        this.allEvents = this.$refs.provider.items;
      },
    );
  }

  handleEventChange(e) {
    console.log('handleEventChange', e);
    this.showForm = false;
    this.showDrawerSection = false;
    this.showEventForm = true;
    this.showEventDrawerSection = true;
    this.currentAction = 'edit'; // To indicate that we are not in the search of booking
    const event = this.items.find(event => event.id === Number(e.event.id));

    if (event) {
      this.bookingEvent = event;
    }

    this.$store
      .dispatch(`bookingEvent/initializeFormModel`, {
        entity: 'booking-event',
        fetchEntity: this.bookingEvent ? true : false,
        id: this.bookingEvent.id,
        formName: 'default',
      })
      .then(res => {
        res.add(() => {
          setTimeout(() => {
            const start = moment(e.event.start);
            const end = moment(e.event.end);

            this.$store.commit('bookingEvent/setModelProp', {
              prop: 'start_time',
              value: start.format('HH:mm'),
            });

            this.$store.commit('bookingEvent/setModelProp', {
              prop: 'end_time',
              value: end.format('HH:mm'),
            });

            this.$store.commit('bookingEvent/setModelProp', {
              prop: 'date',
              value: start.format('YYYY-MM-DD'),
            });

            console.log('RESOURCE', e.event.getResources());
            const resourceId = e.event.getResources()[0] ? e.event.getResources()[0].id : null;

            if (resourceId) {
              const resource = this.resources.find(resource => resource.id === Number(resourceId));
              this.$store.commit('bookingEvent/setModelProp', {
                prop: 'resource',
                value: resource,
              });

              this.$store.commit('bookingEvent/setModelProp', {
                prop: 'resource_id',
                value: resourceId,
              });
            }

            // this.$store.commit('booking/setModel', model);
          }, 1000);
        });
      });

    console.log(e);
  }

  handleDateSelect(selectInfo: DateSelectArg) {
    this.showEventDrawerSection = false;
    this.showEventForm = false;
    this.showForm = true;
    this.showDrawerSection = true;

    setTimeout(() => {
      this.$store.commit(`booking/setInitialModel`, {
        fields: this.$store.getters[`booking/fieldsObject`],
        model: {},
      });

      this.currentAction = 'new'; // To indicate that we are not in the search of booking

      // this.onNew();
      const start = moment(selectInfo.startStr);
      const end = moment(selectInfo.endStr);
      const model = this.$store.getters['booking/model'];
      const resource = this.resources.find(
        resource => resource.id === Number(selectInfo.resource.id),
      );

      set(model, 'time_range.start_time', start.format('HH:mm'));
      set(model, 'start_date', start.format('YYYY-MM-DD'));
      set(model, 'time_range.end_time', end.format('HH:mm'));

      if (resource) {
        set(model, 'resources', [resource]);
      }

      this.$store.commit('booking/setModel', model);
    }, 1000);
  }
  handleConflictEvents(e) {
    const res = e.className !== 'excluded-event';
    if (!res) {
      this.$bpcMessage.showErrorMessage({ text: 'bookings.exclusion_error' });
    }
    return res;
  }

  onEventFormSaved() {
    this.allEvents = [];
    this.onEventFormClose();
    this.$refs.provider.getEntities();
  }

  onFormSave() {
    this.isSavingForm = true;
    console.log('Saving');
    this.allEvents = [];
    this.nextAction = '';
    this.$refs.stdForm.saveEntity();
  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

  onNew() {
    this.entity = null;
    this.$bpcStorage.clear('booking-events');
    this.isSimpleBooking = true;
    this.showForm = true;
    // this.$bvModal.show('modal-resource-form');
    this.showDrawerSection = true;
  }

  onFormSearch() {
    this.isSavingForm = true;
    this.$refs.stdForm.searchEntity();
    this.resourcesSelectInfo = [];
    this.$bpcStorage.clear('booking-events');
  }

  getResources() {
    this.resourcesLoaded = false;
    let params = null;
    if (this.calendarResourceId !== null) {
      params = {
        per_page: 500,
        orderBy: 'ordering',
        orderDirection: 'asc',
        id: this.calendarResourceId,
      };
    } else if (this.exclusionsResourceId !== null) {
      params = {
        per_page: 500,
        orderBy: 'ordering',
        orderDirection: 'asc',
        exclusions_resource_id: this.exclusionsResourceId,
      };
    } else {
      params = {
        per_page: 500,
        orderBy: 'ordering',
        orderDirection: 'asc',
      };
    }

    params['contentForSelector'] = true;
    params['columns'] = ['id', 'center_id', 'name', 'code', 'ordering', 'article_id'];
    params['relationFields'] = ['article'];

    if (this.selectedSectorId) {
      params['sectors__id'] = this.selectedSectorId;
    }

    if (this.$route.query.resource_discipline_id) {
      params['disciplines__id'] = this.$route.query.resource_discipline_id;
    } else if (this.selectedDisciplineId) {
      params['disciplines__id'] = this.selectedDisciplineId;
    }

    if (this.$route.query.resources_id) {
      params['id'] = this.$route.query.resources_id;
    } else if (this.selectedResourcesId) {
      params['id'] = this.selectedResourcesId;
    }

    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('resource'), {
        params: params,
      })
      .subscribe(res => {
        console.log('resource', res);
        this.resources = res.data;
        this.$set(this.calendarOptions, 'resources', this.parseResources(this.resources));
        this.resourcesLoaded = true;
        this.getDisciplines();
      });
  }

  getDisciplines() {
    const params = { per_page: 500 };
    params['resources__id'] = this.resources.map(resource => {
      return resource.id;
    });
    params['contentForSelector'] = true;
    params['columns'] = [
      'id',
      'center_id',
      'code',
      'name',
      'short_name',
      'status',
      'color',
      'ordering',
      'favorite',
    ];

    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('discipline'), {
        params: params,
      })
      .subscribe(res => {
        console.log('discipline', res);
        this.disciplines = res.data;
      });
  }

  parseResources(resources: Resource[]) {
    return resources.map(resource => {
      return {
        id: `${resource.id}`,
        title: this.showResourceNameAsTitle ? resource.name : resource.code,
        name: resource.name,
        ordering: resource.ordering,
      };
    });
  }

  selectDiscipline(id: number): void {
    this.selectedDisciplineId = id;
    this.getResourcesIfNothingChange();
  }

  selectResources(ids: number[]): void {
    this.selectedResourcesId = ids;
    this.getResourcesIfNothingChange();
  }

  getSlotPricesCategories() {
    const params = this.$refs.provider.queryConfig.params;
    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('schedule-slot-ranges') + '/ranges-by-date', {
        params,
      })
      .subscribe(res => {
        const slots = res.data.map(slot => {
          return {
            start: this.formatDateTime(params.date, slot.start_time),
            end: this.formatDateTime(params.date, slot.end_time),
            backgroundColor: `${slot.color}`,
            borderColor: `${slot.color}`,
            display: 'background',
          };
        });
        this.allEvents = this.allEvents.concat(slots);
        this.$set(this.calendarOptions, 'events', this.allEvents);
        if (this.$refs.fcalendar) {
          this.$refs.fcalendar.$emit('rerender-events');
        }
      });
  }

  getResourceConflicts() {
    const params = this.$refs.provider.queryConfig.params;
    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('booking-event') + '/resource-conflicts', {
        params,
      })
      .subscribe(res => {
        const excludedEvents = res.data.map(excludedEvent => {
          return {
            id: excludedEvent.id,
            title: excludedEvent.name,
            start: this.formatDateTime(excludedEvent.date, excludedEvent.start_time),
            end: this.formatDateTime(excludedEvent.date, excludedEvent.end_time),
            backgroundColor: '#cecece',
            borderColor: '#cecece',
            resourceId: `${excludedEvent.resource_id}`,
            className: 'excluded-event',
            display: 'background',
          };
        });
        this.allEvents = this.allEvents.concat(excludedEvents);
        this.$set(this.calendarOptions, 'events', this.allEvents);
        if (this.$refs.fcalendar) {
          this.$refs.fcalendar.$emit('rerender-events');
        }
      });
  }

  get displayEventsWithContactColor() {
    return this.$store.getters['centerSettings/displayContactColorInBookingCalendar'];
  }

  addEventsToCalendar() {
    this.items = this.$refs.provider ? this.$refs.provider.items : null;
    const events = this.items.map(event => {
      const color = this.displayEventsWithContactColor
        ? event.contact?.color
        : event?.discipline?.color;
      return {
        id: event.id,
        title: '',
        start: this.formatDateTime(event.date, event.start_time),
        end: this.formatDateTime(event.date, event.end_time),
        backgroundColor: color,
        borderColor: color,
        resourceId: `${event.resource_id}`,
      };
    });
    console.log('events', events);
    this.allEvents = this.allEvents.concat(events);
    this.$set(this.calendarOptions, 'events', this.allEvents);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('rerender-events');
    }
    // this.calendarOptions.eventsSet;
  }

  gotoCurrentDate() {
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.getApi().gotoDate(this.filterDate);
    }
  }

  formatDateTime(date, time): string {
    return moment(`${date} ${time}`).toISOString();
  }

  hasBookingEvents(): boolean {
    return this.isSimpleBooking ? false : !!this.$store.getters['booking/model'].bookingEvents;
  }

  onFormSearched() {
    this.currentAction = 'search'; // To indicate that we are not in the search of booking
  }

  syncDateFilterModel(model) {
    console.log('syncFilterModel', model);
    if (model) {
      this.updateHeadingDate(model.date);
      this.$set(this.stdFilterModel, 'date', model.date || null);
    }
  }

  syncSectorFilterModel(model) {
    console.log('syncFilterModel', model);
    if (model) {
      this.$set(this.stdFilterModel, 'resource__sectors__id', model.resource__sectors__id || null);
    }
  }

  updateHeadingDate(date) {
    this.headingDate = '';
    if (date) {
      const locale = this.getLang() === 'be' ? 'fr' : this.getLang();
      this.headingDate = moment(date)
        .locale(locale)
        .format('dddd DD/MM/YYYY')
        .toUpperCase();
    }
  }

  checkRouteQueryParams() {
    const query = this.$route.query;
    if ('showPageTitle' in query && query.showPageTitle !== 'true') {
      this.showPageTitle = false;
    }

    if ('showSectors' in query && query.showSectors === 'true') {
      this.showSectors = true;
    }

    if ('hideHeading' in query && query.hideHeading === 'true') {
      this.hideHeading = true;
    }

    if ('showResourceNameAsTitle' in query && query.showResourceNameAsTitle === 'true') {
      this.showResourceNameAsTitle = true;
    }

    // Set in the query params to avoid losing it when change a filter
    if ('resources_id' in query) {
      this.$set(this.$refs.provider.queryConfig.params, 'resources_id', [...query.resources_id]);
    }
  }

  checkRouteQueryParamsOnCreated() {
    const query = this.$route.query;
    if ('hideFilters' in query && query.hideFilters === 'true') {
      this.hideFilters = true;
    }

    // Set to have initial filters for the booking query
    if ('resources_id' in query) {
      this.bookingEventInitialFilters = [
        { filterField: 'resources_id', value: [...query.resources_id] },
      ];
    }

    if ('showSectors' in query && query.showSectors === 'true') {
      this.showSectors = true;
    }

    if ('showResourceNameAsTitle' in query && query.showResourceNameAsTitle === 'true') {
      this.showResourceNameAsTitle = true;
    }
  }

  bookingEventInitialFilters = [];

  onChangeFilter() {
    if (
      this.$refs.provider &&
      this.$refs.provider.canLoadEntities &&
      this.$refs.provider.firstLoadEntities
    ) {
      let changed = false;
      changed = this.setQueryConfigParams();
      if (changed) {
        // Only do the request if there was a change in the filters (to avoid duplicate request in the initialization of the filter component)
        // this.$router.push({ query: this.$refs.provider.queryConfig.params }).catch(e => {
        //   return null;
        // });
        this.pushParamsToUrl();

        this.selectedDisciplineId = this.$refs.provider.queryConfig.params.resource_discipline_id;
        this.selectedResourcesId = this.$refs.provider.queryConfig.params.resources_id;

        this.$refs.provider.getEntities();
        this.updatePageActions();
        this.updateRowActions();
        if (this.$refs.fcalendar) {
          this.$refs.fcalendar.$emit('rerender-events');
        }
      }
    }
  }

  pushParamsToUrl() {
    const params = {};
    if (this.$refs.provider.queryConfig.params.resource_discipline_id) {
      params[
        'resource_discipline_id'
      ] = this.$refs.provider.queryConfig.params.resource_discipline_id;
    }
    if (this.$refs.provider.queryConfig.params.resources_id) {
      params['resources_id'] = this.$refs.provider.queryConfig.params.resources_id;
    }
    if (this.hideHeading) {
      params['hideHeading'] = true;
      params['noPadding'] = true;
    }
    if (this.hideFilters) {
      params['hideFilters'] = true;
    }
    if (this.showResourceNameAsTitle) {
      params['showResourceNameAsTitle'] = true;
    }
    this.$router.push({ query: params }).catch(e => {
      return null;
    });
  }

  restoreCalendar() {
    setTimeout(() => {
      this.$refs.fcalendar.getApi().setOption('nowIndicator', true);
      this.$refs.fcalendar.getApi().changeView('resourceTimeGrid');
    }, 500);
  }

  private getParamsThatCanGetResources() {
    return [this.selectedSectorId, this.selectedDisciplineId, this.selectedResourcesId].join(',');
  }

  getResourcesIfNothingChange() {
    const oldParamsThatCanGetResources = this.getParamsThatCanGetResources();
    setTimeout(() => {
      const newParamsThatCanGetResources = this.getParamsThatCanGetResources();
      if (newParamsThatCanGetResources === oldParamsThatCanGetResources) {
        this.getResources();
      }
    }, 300);
  }

  /* Lifecycle hooks */

  created() {
    this.checkRouteQueryParamsOnCreated();
    if (!this.showSectors) {
      this.getResources();
    }
  }

  mounted() {
    this.checkRouteQueryParams();
    this.$root.$on('sector-tabs-loaded', event => {
      this.filterSectorsLoaded = true;
    });
    this.$bpcEcho.listenUpdateCenterSettings();
    window.addEventListener('afterprint', this.restoreCalendar);
  }
  // updated () { }
  destroyed() {
    this.$bpcEcho.leaveUpdateCenterSettings();
    this.$root.$off('sector-tabs-loaded');
    window.removeEventListener('afterprint', this.restoreCalendar);
  }

  @Watch('filterDate')
  onChangeFilterDate() {
    this.allEvents = [];
    this.gotoCurrentDate();
  }

  @Watch('selectedSectorId')
  onChangeSelectedSectorId() {
    this.allEvents = [];
    this.getResourcesIfNothingChange();
  }

  @Watch('selectedDisciplineId')
  onChangeSelectedDisciplineId(val) {
    this.allEvents = [];
    this.selectDiscipline(val);
  }

  @Watch('selectedResourcesId')
  onChangeSelectedResourcesId(val) {
    this.allEvents = [];
    this.selectResources(val);
  }

  @Watch('startLoadingEntities')
  onStartLoadingEntities() {
    if (this.startLoadingEntities === true) {
      this.getResourceConflicts();
      this.getSlotPricesCategories();
    }
  }

  @Watch('slotMinTime')
  onChangeSlotMinTime() {
    this.$set(this.calendarOptions, 'slotMinTime', this.slotMinTime);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('render');
    }
  }

  @Watch('slotMaxTime')
  onChangeSlotMaxTime() {
    this.$set(this.calendarOptions, 'slotMaxTime', this.slotMaxTime);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('render');
    }
  }

  @Watch('slotDuration')
  onChangeSlotDuration() {
    const hours = Math.floor(this.slotDuration / 60);
    const minutes =
      this.slotDuration % 60 < 10 ? `0${this.slotDuration % 60}` : this.slotDuration % 60;
    const slotDurationFormated = `${hours}:${minutes}:00`;
    this.$set(this.calendarOptions, 'slotDuration', slotDurationFormated);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('render');
    }
  }

  @Watch('hideHeading')
  onChangeHideHeading(val) {
    this.pushParamsToUrl();
  }

  @Watch('hideFilters')
  onChangeHideFilters(val) {
    this.pushParamsToUrl();
  }

  @Watch('showResourceNameAsTitle')
  onChangeShowResourceNameAsTitle(val) {
    this.pushParamsToUrl();
  }

  @Watch('filterSectorsLoaded')
  onChangeFilterSectorsLoaded() {
    if (!this.selectedSectorId) {
      this.getResourcesIfNothingChange();
    }
  }

  get canConfigView() {
    return this.$authorizationService.hasPermissions(['manage_bookings']);
  }
}
